import React from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'

const VenueDropdown = ({ selected, options = [], onChange }) => (
  <ReactSelect
    name={'venue'}
    className="w-full md:w-1/5 mt-5 md:mt-0"
    value={options.find(option => option.value === selected)}
    options={[{ value: '', label: 'All Venues' }, ...options]}
    placeholder={'All Venues'}
    onChange={({ value }) => {
      onChange(value)
    }}
    components={{ IndicatorSeparator: () => null }}
  />
)

VenueDropdown.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
}

export default VenueDropdown
